
import { RutaLocal } from '../componentes/funcionesEspeciales'
import Logo from '../media/img/logo_sin_fondo.png'
import Facebook from '../media/img/ico_facebook.png'
import Instagram from '../media/img/ico_instagram.png'
import Tiktok from '../media/img/ico_tiktok.png'
function Footer() {

    return (<>
        <footer>

            <div className="container">
                <div className="text-center pt-5 pb-4">
                    <img src={Logo} className="footerLogo" alt="LOGO " />
                </div>
                <div className="footerarea">
                    <div className="footerNote float-left ">

                        <div>
                            <p></p>
                            <ul className="d-none d-md-flex list-inline site-link ">
                                <li className="visible-xs">
                                    <h5 className="visible-xs d-none d-md-block">TIENDAS & SERVICIOS</h5>
                                    <ul className="nav">
                                        <ul className="list-inline site-link ">
                                            <li><a href={RutaLocal + "sucursales"}>Encuentrános</a></li>
                                        </ul>
                                    </ul>
                                </li>
                                <li className="visible-xs">
                                    <h5 className="visible-xs d-none d-md-block">SOBRE NOSOTROS</h5>
                                    <ul className="nav">
                                        <ul className="list-inline site-link ">
                                            <li><a href={RutaLocal + "historia"} >Historia</a></li>
                                        </ul>
                                    </ul>
                                </li>
                                {/* <li className="visible-xs">
                                    <h5 className="visible-xs d-none d-md-block">GUÍA NUTRICIONAL</h5>
                                    <ul className="nav">
                                        <ul className="list-inline site-link ">
                                            <li><a href="/guia-nutricional" >GUÍA NUTRICIONAL</a></li>
                                        </ul>
                                    </ul>
                                </li> */}

                                <li className="visible-xs">
                                    <h5 className="visible-xs d-none d-md-block">ATENCIÓN AL CLIENTE</h5>
                                    <ul className="nav">
                                        <ul className="list-inline site-link ">
                                            <li><a href={RutaLocal + "contacto"} >Contáctenos</a></li>
                                        </ul>
                                    </ul>
                                </li>

                                <li className="visible-xs">
                                    <h5 className="visible-xs d-none d-md-block">POLÍTICAS Y TÉRMINOS</h5>
                                    <ul className="nav">
                                        <ul className="list-inline site-link ">
                                            <li><a href={RutaLocal + "terminosCondiciones"} >Términos y Condiciones Online</a></li>
                                            <li><a href={RutaLocal + "politicasPrivacidad"} >Políticas de Privacidad</a></li>
                                        </ul>
                                    </ul>
                                </li>
                            </ul>
                            <div className="d-none d-md-block  text-center">
                                <p>SÍGUENOS</p>
                                <ul className="social-link"
                                //style={{ backgroundColor: "red" }}
                                >
                                    <li className="">
                                        <a className="col-md-12" href="https://www.facebook.com/ElGalponpollosyparrillas?mibextid=ZbWKwL" rel="noopener noreferrer " target="_blank">
                                            <div className="sprite-footer ">
                                                <img src={Facebook} width={30} height={30} />
                                            </div>

                                        </a>
                                    </li>

                                    <li className="">
                                        <a className="col-md-12" href="https://www.instagram.com/elgalpon.pollosyparrillas?igsh=eTV3aXVjNDExb3I3" rel="noopener noreferrer " target="_blank">
                                            <div className="sprite-footer">
                                                <img src={Instagram} width={30} height={30} />
                                            </div>

                                        </a>
                                    </li>
                                    <li className="">
                                        <a className="col-md-12" href="https://www.tiktok.com/@el.galp0n?_t=8n26kDNUhrZ&_r=1" rel="noopener noreferrer " target="_blank">
                                            <div className="sprite-footer">
                                                <img src={Tiktok} width={30} height={30} />
                                            </div>

                                        </a>
                                    </li>
                                </ul>

                            </div>
                            <div className="mobile-footer d-md-none text-center">

                                <div className="accordion accordionFooterLink" id="accordionExample">
                                    <div className="card">
                                        <div className="card-header" id="headingAbts">
                                            <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseAbts" aria-expanded="true" aria-controls="collapseAbts">
                                                    TIENDAS & SERVICIOS<i className="fa" aria-hidden="true"></i>
                                                </button>
                                            </h5>
                                            <div id="collapseAtention" className="collapse" aria-labelledby="headingAbts" data-parent="#accordionExample">
                                                <div className="card-body">
                                                    <div className="mobile-footer-links">
                                                        <a href={RutaLocal + "sucursales"} >Sucursales</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header" id="headingAbts">
                                            <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseContact" aria-expanded="true" aria-controls="collapseAbts">
                                                    SOBRE NOSOTROS<i className="fa" aria-hidden="true"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseContact" className="collapse" aria-labelledby="headingAbts" data-parent="#accordionExample">
                                            <div className="card-body">
                                                <div className="mobile-footer-links">
                                                    <a href={RutaLocal + "historia"} >Historia</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header" id="headingAbts">
                                            <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseAtention" aria-expanded="true" aria-controls="collapseAbts">
                                                    ATENCION AL CLIENTE<i className="fa" aria-hidden="true"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseAtention" className="collapse" aria-labelledby="headingAbts" data-parent="#accordionExample">
                                            <div className="card-body">
                                                <div className="mobile-footer-links">
                                                    <a href={RutaLocal + "contacto"} >Contactenos</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header" id="headingPolicy">
                                            <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapsePolicy" aria-expanded="true" aria-controls="collapseAbts">
                                                    POLÍTICAS Y TÉRMINOS<i className="fa" aria-hidden="true"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapsePolicy" className="collapse" aria-labelledby="headingPolicy" data-parent="#accordionExample">
                                            <div className="card-body">
                                                <div className="mobile-footer-links">
                                                    <a href={RutaLocal + "terminosCondiciones"} >Términos y Condiciones Online</a>
                                                    <a href={RutaLocal + "politicasPrivacidad"} >Políticas de Privacidad </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-center pt-2">
                                    <div className="pt-2"><ul className="social-link">
                                        <li className="">
                                            <a className="col-md-12" href="https://www.facebook.com/ElGalponpollosyparrillas?mibextid=ZbWKwL" rel="noopener noreferrer " target="_blank">
                                                <div className="sprite-footer ">
                                                    <img src={Facebook} width={30} height={30} />
                                                </div>

                                            </a>
                                        </li>
                                        <li className="">
                                            <a className="col-md-12" href="https://www.instagram.com/elgalpon.pollosyparrillas?igsh=eTV3aXVjNDExb3I3" rel="noopener noreferrer " target="_blank">
                                                <div className="sprite-footer ">
                                                    <img src={Instagram} width={30} height={30} />
                                                </div>

                                            </a>
                                        </li>

                                        <li className="">
                                            <a className="col-md-12" href="https://www.tiktok.com/@el.galp0n?_t=8n26kDNUhrZ&_r=1" rel="noopener noreferrer " target="_blank">
                                                <div className="sprite-footer ">
                                                    <img src={Tiktok} width={30} height={30} />
                                                </div>

                                            </a>

                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="row  margin-top-20">
                        <div className="col-12 footer-terms">
                            <div className="mb-3">
                                <p className="text-center">
                                    ©Pollerias El Galpon
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>)
}
export default Footer;